import { useEffect } from "react";

export function useClassicRoomSocket(
  socket,
  roomName,
  setNumPrompts,
  setWaitingForPrompts
) {
  useEffect(() => {
    socket.emit("join room", roomName);
    socket.on("numPrompts", (msg) => setNumPrompts(msg));
    socket.on("waitingForPrompts", () => setWaitingForPrompts(true));
    socket.on("stopWaitingForPrompts", () => setWaitingForPrompts(false));

    return () => {
      socket.off("connect");
      socket.off("numPrompts");
      socket.off("waitingForPrompts");
      socket.off("stopWaitingForPrompts");
    };
  }, [socket, roomName, setNumPrompts, setWaitingForPrompts]);
}
